export const TRANSACTIONS_SEARCH_RESULTS_TEST_ID =
  'transactions-search-results';
